import { AnomalyEventType, IAnomalyEvent, IMetricAnomalyEvent, IMetricModelOutput } from "@edgetier/watchtower-types";

/**
 * Figure out the main metric to chart. This will just be the first metric for now.
 * @param anomalyEvents Events in the current anomaly.
 * @returns             The primary metric in the anomaly.
 */
export const getMetricId = (anomalyEvents: IAnomalyEvent[]) => {
    const firstAnomalyEvent = anomalyEvents
        .filter(({ anomalyEventType }) => anomalyEventType === AnomalyEventType.New)
        .find((anomalyEvent): anomalyEvent is IMetricAnomalyEvent => "metricId" in anomalyEvent.details);

    return firstAnomalyEvent?.details.metricId ?? void 0;
};

/**
 * Ensure only one metric is selected. This is expected to happen anyway, but something could go wrong if no metric ID
 * was found in the anomaly events.
 * @param metricModelOutputs All metric values provided by a model.
 * @returns                  Metric model outputs.
 */
export const selectMetric = (metricModelOutputs: IMetricModelOutput[]) => {
    return metricModelOutputs.filter(
        (metricModelOutput) => metricModelOutput.metricId === metricModelOutputs[0].metricId
    );
};
